import React, { FunctionComponent } from "react";
import { DraggableProvided, DraggableStateSnapshot } from "react-beautiful-dnd";
import { Button } from "antd";
import { Modal as AtticusModal } from "../../../Shared/Modal";

import {
  SceneIcon,
  CloseIconWithoutBackground,
} from "../../../../content/icons";

//store
import { useOnlineStatus } from "../../../../utils/isOffline";

// types
import { SceneMeta } from "../../../../types/scene";
import { useSideBarActions } from "../../../../utils/hooks/useSideBarActions";
import useRootStore from "../../../../store/useRootStore";
import { SideBarSceneItem } from "../../../../types/sidebar";
import ContextMenu from "../../ContextMenu";
import { ellipsizeTitle } from "../../../../utils/strings";
import useContextMenu from "../../../../utils/hooks/useContextMenu";


interface SceneBlockItemProps {
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  item: SideBarSceneItem;
}

const SceneItem: FunctionComponent<SceneBlockItemProps> = ({
  item,
  provided,
  snapshot,
}: SceneBlockItemProps) => {
  const { sceneIndex: selectedSceneIndex, chapter: editorChapter } =
    useRootStore().bookStore;
  const { scene, chapter, level, id } = item;
  const { sceneIndex, sceneName } = scene!;
  const isActive =
    selectedSceneIndex == sceneIndex && editorChapter._id === chapter._id;
  const { handleDeleteScene } = useSideBarActions();
  const { captureClickEvent } = useRootStore().sideMenuStore;
  const listItemRef = React.createRef<HTMLAnchorElement>();
  const [displayContextMenu, anchorPoints] = useContextMenu(listItemRef);
  const [open, setOpen] = React.useState(false);

  const isOnline = useOnlineStatus();

  const handleDelete = (scene: SceneMeta) => {
    handleDeleteScene(chapter._id, scene.sceneIndex, false);
    setOpen(false);
  };
  const handleMergeAndDelete = (scene: SceneMeta) => {
    handleDeleteScene(chapter._id, scene.sceneIndex, true);
    setOpen(false);
  };

  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      style={{
        ...provided.draggableProps.style,
        paddingLeft: level > 0 ? `${level + 1.8}rem` : "",
      }}
    >
      <div
        className={`chapter-block-item${snapshot.isDragging ? " hover" : ""} ${
          isActive ? " active" : ""
        } `}
      >
        <div className="chapter-block-item-container">
          <a
            onClickCapture={(e) =>
              captureClickEvent(e, chapter._id, scene.sceneIndex)
            }
            ref={listItemRef}
          >
            <div className="chapter-block-item-info-container">
              <div className="chapter-block-item-icon-container">
                <span className="chapter-block-icon">
                  {" "}
                  <SceneIcon color={isActive ? "#3568BA" : "#171D21"} />
                </span>
              </div>
              <div className="chapter-block-item-chapter-name-cover">
                <p
                  className={`chapter-block-item-chapter-name ${
                    isActive ? " active" : ""
                  }`}
                >
                  {sceneName
                    ? ellipsizeTitle(sceneName)
                    : `Scene ${sceneIndex + 1}`}
                </p>
              </div>
            </div>
          </a>
          <ContextMenu
            canDisplay={displayContextMenu}
            top={anchorPoints ? anchorPoints.top - 225 : 0}
            left={anchorPoints?.left}
          />

          <div className="action-group">

            <AtticusModal
              open={open}
              centered={true}
              title={<b>Delete scene</b>}
              onCancel={() => {
                setOpen(false);
              }}
              destroyOnClose={true}
              leftBtn={{
                type: "at-secondary",
                className: "link-modal-btn",
                backgroundColor: "green",
                onMouseDown: () =>
                  handleMergeAndDelete({ sceneIndex, sceneName }),
                children: "Merge Content",
              }}
              rightBtn={{
                type: "at-primary",
                danger: true,
                onMouseDown: () => {
                  handleDelete({ sceneIndex, sceneName });
                },
                children: "Delete content",
              }}
            >
              {" "}
              <p className="delete-modal-bottom-padding">
                How do you want to delete "{<b>{sceneName}</b>}"?
              </p>
            </AtticusModal>

            {isOnline && (
              <Button
                type="text"
                shape="round"
                size="large"
                className="action-btn"
                onMouseDown={() => {
                  setOpen(true);
                }}
              >
                <span className="chapter-block-icon">
                  <CloseIconWithoutBackground />
                </span>
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SceneItem;
